import { TenantContext } from '@interxfi/api-client/realm-context';
import { O5_DEPLOYMENT_BASE_PATH } from '../../features/o5/deployment/o5-deployment-routing';

export const DEFAULT_AUTHENTICATED_ROUTE = '/registration/profile';
export const BACKUP_AUTHENTICATED_ROUTE = '/user';
export const USER_SETTINGS_ROUTE = '/settings/personal';
export const DEFAULT_UNAUTHENTICATED_ROUTE = '/login';
export const MFA_SETUP_ROUTE = '/mfa-setup';

export function getDefaultRouteForAccess(tenantType: TenantContext | undefined): string {
  switch (tenantType) {
    case TenantContext.Organization:
    case TenantContext.Platform:
      return BACKUP_AUTHENTICATED_ROUTE;
    case TenantContext.Program:
      return '/dashboard';
    case TenantContext.Clearing:
      return DEFAULT_AUTHENTICATED_ROUTE;
    case TenantContext.O5:
      return O5_DEPLOYMENT_BASE_PATH;
    default:
      return BACKUP_AUTHENTICATED_ROUTE;
  }
}
